/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_TitleInputs */

const tr_landing_telegram_title = /** @type {(inputs: Landing_Telegram_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onaylayın, imzalayın, yazdırın.`)
};

const en_landing_telegram_title = /** @type {(inputs: Landing_Telegram_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve, sign, print.`)
};

const de_landing_telegram_title = /** @type {(inputs: Landing_Telegram_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen, signieren, drucken.`)
};

const ru_landing_telegram_title = /** @type {(inputs: Landing_Telegram_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждайте, подписывайте, печатайте.`)
};

/**
* | output |
* | --- |
* | "Approve, sign, print." |
*
* @param {Landing_Telegram_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_title = /** @type {((inputs?: Landing_Telegram_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_title(inputs)
	if (locale === "de") return de_landing_telegram_title(inputs)
	if (locale === "ru") return ru_landing_telegram_title(inputs)
	return tr_landing_telegram_title(inputs)
});